<div class="grid-tab tab grid-wrapper" [ngClass]="layoutStyle()">
    <div class="content" style="width: 100%; height: 100%">
        <ag-grid-angular
            style="width: 100%"
            class="ag-theme-custom"
            [columnDefs]="columnDefs()"
            [rowData]="gridData()"
            (gridReady)="onGridReady($event)"
            [autoGroupColumnDef]="autoGroupColumnDef"
            [enableCharts]="false"
            [theme]="theme"
            [rowGroupPanelShow]="'onlyWhenGrouping'"
            [groupTotalRow]="'bottom'"
            (columnVisible)="onColumnVisibleChange($event)"
            [gridOptions]="gridOptions()"
            (columnRowGroupChanged)="onColumnRowGroupChanged($event)"
            [tooltipShowDelay]="0"
            [suppressAggFuncInHeader]="true"
            [cellSelection]="true"
        >
        </ag-grid-angular>
    </div>
    @if (isLoading()) {
        <app-loading-spinner [placeholder]="'Loading data...'" [isOverlay]="true"></app-loading-spinner>
    }
</div>
